import ENV from 'rise-ui/config/environment.js';
import { join } from 'rise-ui/utils/string.js';

const DATA = ENV.APP.API.DATA;

let url;
export function apiUrl() {
  return url ??= join([ DATA.EXPOSED_URL, DATA.NAMESPACE ], '/');
}

export function apiOpen(target) {
  window.open(apiUrl(), target || '_blank');
}
